<!--
  Fake Top

  @since 2021-10-20
  @author mk.ko
-->

<template>
  <header>
    <div class="page-header navbar navbar-fixed-top sticky">
      <div class="page-header-content"/>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'FakeTop',
    components: {},
    props: {},
    data () {
      return {}
    },
    computed: {},
    methods: {},
    watch: {}
  }
</script>

<style scoped>
</style>
